import {clsx} from 'clsx';
import React, {useEffect} from 'react';

import {recordRumAction} from '../../../../util/datadog/datadogRum';
import {IconInfo} from '../../../components/Icon';
import {Tailwind} from '../../../components/Tailwind';

type ErrorMessage = {
  panelID?: string;
  panelViewType?: string;
  mediaType?: string;
  metaInfo?: Record<string, number | string | boolean>; // any additional information useful for segmentation in Datadog
} & (
  | {
      message: React.ReactChild;
      logErrorMessage: string;
    }
  | {message: string}
);

type PanelErrorProps = {
  className?: string;
} & ErrorMessage;

const PanelError: React.FC<PanelErrorProps> = React.memo(props => {
  useEffect(() => {
    // HACK: There are race conditions in data loading (particularly with line plots) that cause PanelError to be
    // imperceptibly mounted on screen before the `loading` state is set to `true`. We only care if
    // the PanelError is rendered for more than `timeout` milliseconds.
    const timeout = setTimeout(() => {
      recordRumAction('panel_error_rendered', {
        ...props.metaInfo,
        message:
          typeof props.message !== 'string' && 'logErrorMessage' in props
            ? props.logErrorMessage
            : props.message,
        panelID: props.panelID, // used for datadog de-duping of errors since virtualized panels will often re-render when scrolling
        panelViewType: props.panelViewType,
        mediaType: props.mediaType,
        // @ts-ignore - GIT_TAG is set in window.CONFIG in the app
        gitTag: window.CONFIG?.GIT_TAG,
      });
    }, 50);

    return () => {
      clearTimeout(timeout);
    };
  }, [props]);

  return (
    <div
      className={clsx('panel-error', props.className)}
      data-test="panel-error">
      <Tailwind>
        <IconInfo width={24} height={24} className="m-auto mb-4" />
        <div>{props.message}</div>
      </Tailwind>
    </div>
  );
});
export default PanelError;
